import { httpClient } from '@/Common/api/http_client';

// =========================================
// Merchant Specific APIs starts
/**
 *
 * @returns {Promise<AxiosResponse<T>>}
 */
export function getAllStatuses() {
  return httpClient.get('/merchant/statuses');
}

/**
 *
 * @param statusId
 * @returns {Promise<AxiosResponse<T>>}
 */
export function deleteStatus(statusId) {
  return httpClient.delete(`/merchant/statuses/${statusId}`);
}

/**
 *
 * @param statusId
 * @param status
 * @returns {Promise<AxiosResponse<T>>}
 */
export function updateStatus(statusId, status) {
  return httpClient.put(`/merchant/statuses/${statusId}`, status);
}

/**
 *
 * @param status
 * @returns {Promise<AxiosResponse<T>>}
 */
export function newStatus(status) {
  return httpClient.post('/merchant/statuses', status);
}

// Merchant Specific APIs ends
// =========================================
